import { useState } from 'react';
import ProfilePosts from './ProfilePosts';
import ProfileSaved from './ProfileSaved';

export const ProfileTabs = ({ profile, isOwner, posts, savedPosts, onLike, onSave, onPostDelete, onPostUpdate, currentUserId }) => {
  const [tab, setTab] = useState('posts');

  return (
    <div className="mt-4">
      <div className="flex border-b border-gray-200">
        <button
          onClick={() => setTab('posts')}
          className={`px-6 py-3 font-medium text-sm transition-colors relative ${
            tab === 'posts'
              ? 'text-[#FF9933]'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Posts
          {tab === 'posts' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FF9933]"></div>
          )}
        </button>

        {isOwner && (
          <button
            onClick={() => setTab('saved')}
            className={`px-6 py-3 font-medium text-sm transition-colors relative ${
              tab === 'saved'
                ? 'text-[#FF9933]'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Saved
            {tab === 'saved' && (
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FF9933]"></div>
            )}
          </button>
        )}
      </div>

      <div className="p-4">
        {tab === 'posts' && <ProfilePosts posts={posts} onLike={onLike} onSave={onSave} onPostDelete={onPostDelete} onPostUpdate={onPostUpdate} currentUserId={currentUserId} />}
        {tab === 'saved' && isOwner && <ProfileSaved savedPosts={savedPosts} onLike={onLike} onSave={onSave} onPostDelete={onPostDelete} onPostUpdate={onPostUpdate} currentUserId={currentUserId} />}
      </div>
    </div>
  );
};

export default ProfileTabs;
